/** @jsx jsx */

import { Children, Fragment as _, memo, cloneElement } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import PDF from 'components/lib/PDF';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import EditableBtn from 'components/lib/EditableBtn';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import Embed from 'components/lib/Embed';
import { Block } from '@chameleoncreator/creator-app';
import getBlockById from 'services/apiHelpers/getBlockById';
import shouldUpdate from 'services/shouldUpdate';
import IELayout from 'components/Layouts/IELayout';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import Media_default from 'assets/Rectangle.png';
import imageSVGAnimation from 'assets/animations/phoneWoman.js';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: EditableText,
  Image: ({ children, ...props }) => {
    const updatedProps = {
      ...props,
    };

    if (!props.src) {
      updatedProps.placeholder = Media_default;
    }

    return <Image {...{ ...updatedProps, usePlaceholderValue: true }} />;
    //
  },
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  Video,
  Audio,
  SVG,
  PDF,
  OpenPDF,
  Media,
  Embed,
  Transcript: ({ children }) => children,
  ...IELayout(interactionContext),
};

const MultiMediaDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{
          ...interactionBlock,
          isOpen: props.isOpen,
          updateItemsSeen: null,
        }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default MultiMediaDisplay;
